module.exports = __webpack_public_path__ + "img/sld_mfm_inv_2_t1_b1_dark.5ab5cbb9.svg";